export default {
    noResultsText: 'Nenhum resultado encontrado',
    searching: 'Procurando...',
    minDigits: 'Digite ao menos 3 caracteres',
}
